let globalEl = null;

export function getGlobalAudio() {
  return globalEl || null;
}

export function setGlobalAudio(el) {
  globalEl = el || null;
}

export function ensureExclusive(el) {
  try {
    if (!el) return;
    const current = getGlobalAudio();
    if (current && current !== el) {
      try { current.pause(); } catch {}
      try { current.currentTime = current.currentTime; } catch {}
    }
    setGlobalAudio(el);
  } catch {}
}

export function pauseGlobal() {
  const current = getGlobalAudio();
  if (!current) return;
  try { current.pause(); } catch {}
}